import React from 'react';
import Field from '../Field';
import { Form } from 'semantic-ui-react';

const options = [
  { key: 0, text: 'Less than 2 hours', value: 'overall_delay_less_than_2' },
  { key: 1, text: 'Between 2 and 3 hours', value: 'overall_delay_between_2_and_3' },
  { key: 2, text: 'Between 3 and 4 hours', value: 'overall_delay_between_3_and_4' },
  { key: 3, text: 'More than 4 hours', value: 'overall_delay_more_than_4' },
  { key: 4, text: 'Decided to cancel', value: 'decided_to_cancel' },
  { key: 5, text: 'Less than 3 hours', value: 'less_than_3_hours' }
]

const OverallDelayDropdown = ({ width, error, touched, name, label, value, onChange, onBlur }) => (
  <Field width={width} error={error} touched={touched} >
    <Form.Dropdown
      fluid
      label={label}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      options={options}
      placeholder={label}
      search
      selection
      value={value}
    />
  </Field>
)

export default OverallDelayDropdown;



// WEBPACK FOOTER //
// ./src/component/dropdowns/OverallDelayDropdown.js